import { create } from 'zustand';
export const authStore = create()(() => ({
    userId: null,
    isGuest: false,
    isAuthenticated: false,
}));
